import { User } from 'firebase/auth';

import { Subscriber } from './projects';
import { API_URL } from '../config';

export interface AnalyticsSummary {
  projectId: string;
  subscriberCount: number;
  totalEvents: number;
  totalPageViews: number;
  viewsPerDay: Array<{ date: string; count: number }>;
  uniqueViewsPerDay: Array<{ date: string; count: number }>;
  subscribers: Subscriber[];
}

/** Fetch analytics summary for a project. */
export async function getAnalyticsSummary(
  user: User,
  projectId: string,
): Promise<AnalyticsSummary> {
  const token = await user.getIdToken();
  const res = await fetch(`${API_URL}/analytics/${projectId}/summary`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    const error = await res.json().catch(() => ({
      error: 'Our data service is having a moment — try refreshing the page.',
    }));
    throw new Error(
      error.error || 'Our data service is having a moment — try refreshing the page.',
    );
  }

  return res.json();
}
